export const errorMessages = Object.freeze({
  FAVORITES_EMPTY: "You don't have any favorite patches yet.",
  PATCHES_EMPTY: "Sorry, no patches match that filter.",
});
